import { connect } from 'react-redux'
import ArchivedEntry from './archived-entry'
import {
  getInvitation,
  getRemoveInvitationRequest
} from '../../../../../../stores/archived-invitations/archived-invitations.selectors'
import { format } from 'date-fns'

const mapStateToProps = (state, { id }) => {
  const archivedInvitation = getInvitation(state, id)
  const removeInvitationRequest = getRemoveInvitationRequest(state, id)
  return {
    id: archivedInvitation.id,
    title: archivedInvitation.assessment_file.title,
    invitedBy: archivedInvitation.invited_by.full_name,
    invitedAt: format(archivedInvitation.updated_at, 'DD.MM.YYYY'),
    link: `/assessment-files/${archivedInvitation.assessment_file.id}`,
    seen: archivedInvitation.seen,
    conclusion: archivedInvitation.assessment_file.concluded,
    pending: removeInvitationRequest.pending
  }
}

export default connect(mapStateToProps, null)(ArchivedEntry)
